// Phase 5F — frontend wrappers for /api/ai/scheduling/*.
import axios from "axios";
import { API } from "@/contexts/AuthContext";

const BASE = `${API}/ai/scheduling`;

export async function fetchSchedulingAiCatalogue() {
  try {
    const { data } = await axios.get(`${BASE}/catalogue`, { withCredentials: true });
    return { enabled: true, data };
  } catch (e) {
    if (e?.response?.status === 503) return { enabled: false };
    throw e;
  }
}

export async function schedulingAiNl(message) {
  const { data } = await axios.post(`${BASE}/nl`, { message }, { withCredentials: true });
  return data;
}

export async function schedulingAiConfirm(action_row_id, confirmation_token) {
  const { data } = await axios.post(
    `${BASE}/confirm`,
    { action_row_id, confirmation_token },
    { withCredentials: true });
  return data;
}

export async function schedulingAiCancel(action_row_id) {
  const { data } = await axios.post(
    `${BASE}/cancel`, { action_row_id }, { withCredentials: true });
  return data;
}
